module.exports = __webpack_public_path__ + "fonts/intelo-light.7568acf.woff";